import { Tooltip } from "react-tooltip";
import styles from "./DefaultTooltip.module.scss";

const timeFast = 500;
const timeSlow = 2000;
const styleBorder = "1px solid darkgray";

export default function DefaultTooltip({ handle, children }) {
  return (
    <Tooltip id={handle} className={styles["default"]} border={styleBorder}>
      {children}
    </Tooltip>
  );
}

export const getTimeFast = () => {
  return timeFast;
};

export const getTimeSlow = () => {
  return timeSlow;
};

